import axiosInstance from "../axios_instance";

export async function verifyLockPin(body) {
  try {
    return await axiosInstance.post(`user/verify_lock_pin`, body);
  } catch (error) {
    return error;
  }
}

export async function resetLockPin(body) {
  try {
    return await axiosInstance.post(`user/reset_lock_pin`, body);
  } catch (error) {
    return error;
  }
}
